import * as React from "react";
import {useDispatch} from "react-redux";
import {useRouteMatch} from "react-router";
import {Link} from "react-router-dom";
import {Formik} from "formik";
import {apAppLink, apAppPath} from "@web2/ap-routes";
import {Button} from "@web2/button";
import {getFormikFieldProps, IFormikSubmitFn} from "@web2/formik_utils";
import {Input} from "@web2/input";

import {mb_lg, tac} from "../../app/styles/helpers";
import {postNewPassword} from "../actions/post_new_password";
import {authBoxHolder, AuthLogo} from "./LoginForm";

const initialValues = {
    new_password: "",
    re_new_password: ""
};

export const NewPasswordForm = () => {
    const routeParams = useRouteMatch<{uid: string; token: string}>(apAppPath.newPassword)?.params;
    const dispatch = useDispatch();

    const onSubmit: IFormikSubmitFn<typeof initialValues> = (formData, formikHelpers) => {
        if (routeParams) {
            dispatch(
                postNewPassword({
                    ...formData,
                    ...routeParams
                })
            );
        }

        formikHelpers.setSubmitting(false);
    };

    return (
        <div css={authBoxHolder}>
            <AuthLogo />

            <Formik initialValues={initialValues} onSubmit={onSubmit}>
                {(formikProps) => (
                    <form onSubmit={formikProps.handleSubmit}>
                        <div>
                            <Input {...getFormikFieldProps(formikProps, "new_password")} placeholder="Wpisz nowe hasło" type="password" autoFocus required />

                            <Input {...getFormikFieldProps(formikProps, "re_new_password")} placeholder="Powtórz nowe hasło" type="password" required />
                        </div>

                        <div css={[tac, mb_lg]}>
                            <Button type="submit" size="lg" variant="primary" disabled={formikProps.isSubmitting}>
                                Zmień hasło
                            </Button>
                        </div>

                        <div css={[tac]}>
                            <Link to={apAppLink.login()}>Przejdź do strony logowania</Link>
                        </div>
                    </form>
                )}
            </Formik>
        </div>
    );
};
